import { Box } from '@chakra-ui/react'

import { Loading } from '@/components/Loading'
import { Steps } from '@/components/Steps/Steps'
import WizardForbiddenMessage from '@/components/WizardForbiddenMessage'
import { Step1 } from '@/containers/steps/property/Step1'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WithAuth } from '@/hoc/WithAuth'
import { useApp } from '@/hooks/useApp'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { useEffect } from 'react'

const Step1PageComponent = () => {
  const { product, setProduct } = useApp()
  const { insuranceParams: ip, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsPropertyDto

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  return (
    <StepsProvider currentStepId={1}>
      <SidebarProvider>
        <PageWrapper
          steps={<Steps />}
          sidebar={<Sidebar />}
        >
          <Box sx={{ pt: { base: 0, md: 8 } }}>
            {isLoadingData && <Loading large={true} />}

            {(!paramsId || insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType) &&
              <Step1 data={insuranceParams} />
            }

            <WizardForbiddenMessage />
          </Box>
        </PageWrapper>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step1Page = WithAuth(Step1PageComponent)